export const ADD_PERSON_TO_FAVORITE = 'ADD_PERSON_TO_FAVORITE';
export const REMOVE_PERSON_FROM_FAVORITE = 'REMOVE_PERSON_FROM_FAVORITE';